import React, { memo, useCallback, useMemo } from 'react';
import { IconBell } from 'design-system/icons';
import SectionHeader from 'design-system/SectionHeader';
import { SettingsItem } from 'design-system/SettingsItem';
import { TextButtonLinkSeeAll } from 'design-system/TextButton';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import StockAlert from './StockAlert';
const PriceAlertSection = ({ assetId, pendingStockAlerts }) => {
    const navigation = useMainStackNavigation();
    const styles = useStyles(styleSet);
    const handleSetAlert = useCallback(() => {
        if (assetId) {
            navigation.navigateDeprecated('InvestSetStockAlertScreen', {
                assetId,
            });
            return;
        }
        navigation.navigateDeprecated('InvestSearchStock', { stockAlertFlow: true });
    }, [assetId]);
    const handleSeeAll = useCallback(() => {
        if (assetId) {
            navigation.navigateDeprecated('InvestStockAlertScreen', {
                assetId,
            });
            return;
        }
        navigation.navigateDeprecated('InvestStockAlertScreen');
    }, [assetId]);
    const content = useMemo(() => {
        const itemsLength = pendingStockAlerts?.length || 0;
        if (pendingStockAlerts && itemsLength) {
            return (<>
          {pendingStockAlerts.map((stockAlert, index) => (<StockAlert index={index} style={styles.card} key={stockAlert.alertId} symbol={stockAlert.symbol} alertId={stockAlert.alertId} assetId={stockAlert.assetId} itemsLength={itemsLength} alertPriceValue={stockAlert.targetPrice.value} alertPriceCurrency={stockAlert.targetPrice.currency}/>))}
        </>);
        }
        return (<TouchableBounceCard onDark noMarginTop noMarginBottom onPress={handleSetAlert}>
        <SettingsItem icon={<IconBell gradientKey="ultimate"/>} title="Set an alert" description="Get notified when a stock reaches a price you set"/>
      </TouchableBounceCard>);
    }, [handleSetAlert, pendingStockAlerts, styles.card]);
    return (<>
      <SectionHeader largeVerticalMargins horizontalMargins button={<TextButtonLinkSeeAll onPress={handleSeeAll}/>}>
        Price alerts
      </SectionHeader>
      {content}
    </>);
};
export default memo(PriceAlertSection);
const styleSet = createStyleSheets((colors) => ({
    card: {
        backgroundColor: colors.cards.onDark,
    },
}));
